const ROOT = window.Shopify?.routes?.root || '/';
const TRACKING_VERSION = 'aov-v1';
const ALLOWED_AOV_SOURCES = new Set(['fbt_product', 'cart_upsell', 'smart_bundle']);

function getAovAttribution() {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('iast_source') || '';
  if (!ALLOWED_AOV_SOURCES.has(source)) return null;

  return {
    source,
    anchorProductId: params.get('iast_anchor') || '',
    bundleType: params.get('iast_bundle') || '',
  };
}

function setHiddenProperty(form, name, value) {
  if (!value) return;
  let input = form.querySelector(`input[name="${name}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.append(input);
  }
  input.value = value;
}

function applyAovAttribution() {
  const attribution = getAovAttribution();
  if (!attribution) return;

  document.querySelectorAll('.product-information form[action*="/cart/add"]').forEach((form) => {
    setHiddenProperty(form, 'properties[_isarttools_source]', attribution.source);
    setHiddenProperty(form, 'properties[_isarttools_version]', TRACKING_VERSION);
    setHiddenProperty(form, 'properties[_isarttools_anchor_product]', attribution.anchorProductId);
    if (attribution.bundleType) {
      setHiddenProperty(form, 'properties[_isarttools_bundle_type]', attribution.bundleType);
    }
  });
}

function localizeRecommendations() {
  document.querySelectorAll('.product-recommendations :is(h1, h2, h3, h4)').forEach((heading) => {
    const text = String(heading.textContent || '').trim().toLowerCase();
    if (text === 'goes well with...' || text === 'goes well with…' || text === 'goes well with') {
      heading.textContent = 'قد يعجبك أيضًا';
    }
  });
}

function addAssurance() {
  const buyBlock = document.querySelector('.product-information .buy-buttons-block');
  if (!buyBlock || buyBlock.querySelector('.isarttools-product-assurance')) return;

  const note = document.createElement('span');
  note.className = 'isarttools-product-assurance';
  note.setAttribute('role', 'note');
  note.setAttribute('aria-label', 'معلومات قبل إتمام الطلب');

  const review = document.createElement('span');
  review.className = 'isarttools-product-assurance__item';
  review.textContent = 'راجع طلبك قبل الدفع';

  const edit = document.createElement('span');
  edit.className = 'isarttools-product-assurance__item';
  edit.textContent = 'يمكنك تعديل الكمية من السلة';

  const help = document.createElement('a');
  help.className = 'isarttools-product-assurance__link';
  help.href = `${ROOT}pages/contact`;
  help.textContent = 'تحتاج مساعدة؟ تواصل معنا';

  note.append(review, edit, help);
  buyBlock.append(note);
}

function polishProductPage() {
  if (!document.querySelector('.product-information')) return;
  applyAovAttribution();
  localizeRecommendations();
  addAssurance();
}

let queued = false;
function schedulePolish() {
  if (queued) return;
  queued = true;
  window.requestAnimationFrame(() => {
    queued = false;
    polishProductPage();
  });
}

function startProductPolish() {
  polishProductPage();
  const main = document.querySelector('#MainContent');
  if (!main) return;

  const observer = new MutationObserver(schedulePolish);
  observer.observe(main, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startProductPolish, { once: true });
} else {
  startProductPolish();
}
